import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
// import { Checkbox, CheckboxGroup } from 'rsuite';
import { IconButton, Message, Panel, Row, Icon } from 'rsuite'
import TargetGroup from './TargetGroup'
import TargetGroupView from './TargetGroupView'
import scrollToComponent from 'react-scroll-to-component'
import {
  updateSubProjectTargetGroup,
  updateTargetGroup,
} from '../../../redux/actions/targetSetting'
import { doneLoading, startLoading } from '../../../utils/loading'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../../redux/actions/sidebar'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import { saveConfirmActualResult } from '../../../redux/actions/closeOfProject'

export default function TargetGroupWidget(props) {
  const {
    showCommandButton,
    schema,
    checked,
    isConfirmActualResult = false,
    isEdit,
    onChangeIsEdit,
    isSubProject,
    numberOfInstallment,
    onSuccess = () => {},
  } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, watch, errors, control, setValue, clearErrors } = useForm()
  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [formSchema, setFormSchema] = useState(schema)

  const handleUpdateTargetGroup = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await updateTargetGroup(projectId, request)
      if (response.success) {
        setFormSchema(response.model)
        onChangeIsEdit(false)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpdateTargetGroupSubProject = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await updateSubProjectTargetGroup(projectId, request)
      console.log('response', response)
      setFormSchema(response)
      onChangeIsEdit(false)
      await dispatch(getSchemaSubProjectSidebar(projectId))
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  // const handleSaveTargetGroup = async (id, newSchama) => {
  //   console.log('send newSchama', newSchama)
  //   startLoading()
  //   setIsLoading(true)
  //   setIsError(false)
  //   try {
  //     const _schema = await saveTargetGroup(id, newSchama)
  //     setFormSchema(_schema)
  //     setIsEdit(false)
  //   } catch (e) {
  //     setIsError(true)
  //   }
  //   setIsLoading(false)
  //   doneLoading()
  // }

  const onSubmit = (data) => {
    // console.log('data', data)
    // console.log('errors', errors)
    //console.log('formSchema', formSchema)

    // if (data[formSchema.criteriaList.name]) {
    //   formSchema.criteriaList.optionSelected = data[formSchema.criteriaList.name]
    // } else {
    //   formSchema.criteriaList.optionSelected = []
    // }

    //create targetLists for post api
    let targetLists = []
    formSchema.criteriaList.options.forEach((item) => {
      data.optionSelected.forEach((selected) => {
        if (item.value === selected) {
          let _data = {
            id: item.value,
            value: item.numberOfPeople.value,
            description: item.detail.value,
            unit: item?.unit?.value || null,
          }
          targetLists.push(_data)
        }
      })
    })

    let request = {
      targetCriteria: data.targetCriteria,
      targetLists: targetLists,
    }

    if (isSubProject) {
      handleUpdateTargetGroupSubProject(request)
    } else {
      handleUpdateTargetGroup(request)
    }
  }

  const onSubmitConfActualResult = (data) => {
    console.log('onSubmitConfActualResult => ', data)

    let targetLists = []
    formSchema.criteriaList.options.forEach((item) => {
      data.optionSelected.forEach((selected) => {
        if (item.value === selected) {
          let _data = {
            id: item.value,
            value: item.numberOfPeople.value,
            description: item.detail.value,
            unit: item?.unit?.value || null,
          }
          targetLists.push(_data)
        }
      })
    })

    let request = {
      optionSelected: null,
      inputOther: null,
      confType: 'TargetGroups',
      targetLists: targetLists,
      numberOfInstallment: numberOfInstallment,
      inputCriteria: null,
      year: null,
      version: null,
    }

    console.log('request => ', request)

    handleSaveConfirmActualResult(request)
  }

  const handleSaveConfirmActualResult = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await saveConfirmActualResult(projectId, request)
      console.log('response : ', response)
      if (response.success) {
        onSuccess(true)

        // const saveResp = await getCloseOfProjectCoworkerForm(projectId)
        //
        // let _formSchema = cloneDeep(formSchema)
        //
        // _formSchema.optionSelected = saveResp?.forms?.confirmActualResul?.goal?.goalTenYear?.optionSelected || null
        //
        // setCheckedConf(saveResp?.forms?.confirmActualResulChecked?.goalTenYearChecked || null)
        // setFormSchema(_formSchema)

        // await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
        onSuccess(false)
      }
    } catch (e) {
      setIsError(true)
      onSuccess(false)
    }

    setIsLoading(false)
    doneLoading()
  }

  const TargetGroupFormEdit = (
    <TargetGroup
      schema={formSchema}
      register={register}
      Controller={Controller}
      control={control}
      errors={errors}
      setValue={setValue}
      clearErrors={clearErrors}
      isConfirmActualResult={isConfirmActualResult}
    />
  )

  const TargetGroupFormView = <TargetGroupView schema={formSchema} />

  return (
    <Panel
      shaded={!isConfirmActualResult}
      bordered={!!isConfirmActualResult}
      header={formSchema.header}
      defaultExpanded
      collapsible
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? TargetGroupFormEdit : TargetGroupFormView}

      {showCommandButton && (
        <>
          <hr />

          {isEdit ? (
            <div>
              {isError && (
                <Row style={{ marginBottom: '1em' }}>
                  <Message
                    showIcon
                    type="error"
                    description={
                      'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                    }
                  />
                </Row>
              )}

              {isConfirmActualResult ? (
                <>
                  {checked && (
                    <Message
                      showIcon
                      type={checked.checkedType ? 'success' : 'error'}
                      description={
                        <div dangerouslySetInnerHTML={{ __html: checked.detail || '' }} />
                      }
                      style={{ marginBottom: 10 }}
                    />
                  )}

                  <SaveButton
                    icon="views-authorize"
                    onClick={handleSubmit(onSubmitConfActualResult)}
                    // disabled={!!checked?.checkedType || isLoading}
                    disabled={isLoading}
                    children={'ยืนยันการดำเนินการจริง'}
                  />
                </>
              ) : (
                <>
                  <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}></SaveButton>
                  <CancelButton
                    onClick={() => {
                      onChangeIsEdit(!isEdit)
                      setIsError(false)
                    }}
                    disabled={isLoading}
                  ></CancelButton>
                </>
              )}
            </div>
          ) : (
            <>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-edit"
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
              >
                แก้ไข{formSchema.header}
              </IconButton>

              {/*<EditButton*/}
              {/*  onClick={() => {*/}
              {/*    onChangeIsEdit(!isEdit)*/}
              {/*    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })*/}
              {/*  }}*/}
              {/*>*/}
              {/*  แก้ไข{formSchema.header}*/}
              {/*</EditButton>*/}
            </>
          )}
        </>
      )}
    </Panel>
  )
}
